/*global define:false*/
define('plugins/readonly/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({

        });

    });

